export function routeFaceSocketMessage(message, emit) {
	if (!message || (message.type !== 'face_event' && message.type !== 'face_cropping')) {
		return false;
	}

	emit('events_face', message);
	return true;
}

export function replaceManagedSocket(sockets, key, nextSocket) {
	const previousSocket = sockets && sockets[key];
	if (previousSocket && previousSocket !== nextSocket) {
		if (typeof previousSocket.off === 'function') previousSocket.off();
		if (typeof previousSocket.disconnect === 'function') previousSocket.disconnect();
	}
	if (sockets) sockets[key] = nextSocket;
	return previousSocket;
}

export function createEventBusRegistry(eventBus) {
	const handlers = {};
	return {
		on(eventName, handler) {
			handlers[eventName] = handler;
			eventBus.$on(eventName, handler);
		},
		offAll() {
			Object.keys(handlers).forEach(eventName => {
				eventBus.$off(eventName, handlers[eventName]);
			});
		},
	};
}

export function scheduleInitialConnection(callback, delay) {
	return setTimeout(callback, delay);
}

export function cancelInitialConnection(timer) {
	if (timer !== null && timer !== undefined) clearTimeout(timer);
}
